import styled from '@emotion/styled'
import { useFeature } from '@news-mono/web-common'
import React from 'react'
import { colors } from '../../__styling/settings/colors'

const StyledSVG = styled('svg')({
    color: colors.perthnow.redRuby,
    position: 'relative',
    zIndex: 1,
})

const StyledSVGWrap = styled('div')({
    position: 'relative',
    '&::after': {
        content: `''`,
        height: '25px',
        width: '63px',
        position: 'absolute',
        right: '11px',
        bottom: '13px',
        background: 'white',
    },
})

export interface PerthNowLogoHorizontalProps {
    className?: string
    width?: number
    height?: number
    textColor?: string
    isHeader?: boolean
}

export const PerthNowLogoHorizontal: React.FC<PerthNowLogoHorizontalProps> = ({
    className,
    width = 220,
    height = 40,
    textColor = colors.black,
    isHeader = false,
}) => {
    const isPrideLogoEnabled = useFeature('perth-now-pride-logo')
    const isGoMatildasEnabled = useFeature('go-matildas-masthead')

    if (isGoMatildasEnabled && isHeader) {
        return (
            <StyledSVG
                className={className}
                width={width}
                height={height}
                viewBox="0 0 645 113"
                xmlns="http://www.w3.org/2000/svg"
            >
                <title>Perth Now</title>
                <g clipPath="url(#a)">
                    <path
                        fill="#00622F"
                        d="M363.208 0c-18.4 0-33.4 14.8-33.4 33.1v46.1c0 18.3 15 33.1 33.4 33.1h247.9c18.5 0 33.4-14.8 33.4-33.1V33.1c0-18.3-15-33.1-33.4-33.1h-247.9Z"
                    />
                    <path
                        fill="#FFDB03"
                        fillRule="evenodd"
                        d="M357.5 21.4H374v11h.3c3.2-6.9 9.7-12.8 21.4-12.8 18.7 0 25.4 13 25.4 27.1v43.4h-17.4V55.4c0-7.6-.6-20.2-12.8-20.2-11.5 0-16 8.3-16 17.5v37.5h-17.4V21.4Zm109.1 55.1c12.8 0 20.5-9.9 20.5-20.6 0-10.7-7.7-20.6-20.5-20.6s-20.5 9.9-20.5 20.6c0 10.7 7.7 20.6 20.5 20.6Zm0-56.8c21.1 0 37.9 14.5 37.9 36.1s-16.9 36.1-37.9 36.1c-21.1 0-37.9-14.5-37.9-36.1-.1-21.6 16.8-36.1 37.9-36.1Zm54.9 1.7h-18.9l24.3 68.8h18l14.7-47h.3l16.5 47h17.3l23.7-68.8h-17.6l-14.5 48.2h-.3l-15.1-48.2H551l-14.1 48.2h-.3l-15.1-48.2Z"
                        clipRule="evenodd"
                    />
                    <path
                        fill="#00622F"
                        fillRule="evenodd"
                        d="M316 55.2c-.1-22.6-8.9-35.6-30.5-35.6-7.2 0-13.5 1.9-19.5 6.8V.1h-16.9v90.4H266V52.3c0-8.1 4.3-16.4 18.3-16.4 9 0 14.7 6.1 14.7 13.9.1 1.8.1 3.4.1 4.7v36H316V55.2ZM36.4 74.6c-10.9 0-19.7-8.7-19.7-19.4s8.8-19.4 19.7-19.4c8.7 0 16.1 5.6 18.7 13.3.5 1.8.8 3.8.8 5.7 0 4.1-1.2 8.1-3.3 11.5-3.6 5-9.5 8.3-16.2 8.3Zm0-55C16.3 19.6.1 35.6.1 55.3v.5l-.1.1v54.8h16.9V85.3c5.7 3.6 12.4 5.6 19.6 5.6 20.1 0 36.3-16 36.3-35.7 0-19.7-16.3-35.6-36.4-35.6Zm185.1 35.7c0 2.6.3 4.9.9 6.3 2.5 6.2 9.9 11.8 17.7 12.3h.9v16.3c-17.7 0-32.4-12.4-35.7-28.8-.5-2.2-.7-7.2-.7-9.5V1.8h16.9v19.4H240v14.3h-18.5v19.8ZM113.6 35.9c8.5 0 15.7 5.2 18.5 12.6H95.2c2.8-7.4 10-12.6 18.4-12.6ZM130 66c-3.5 5.2-9.5 8.6-16.4 8.6-8.9 0-16.5-5.8-18.9-13.9h54.9c.2-1.9.3-3.6.3-5.5 0-19.7-16.3-35.7-36.3-35.7-20.1 0-36.3 16-36.3 35.7 0 19.7 16.3 35.7 36.3 35.7 12 0 22.7-5.7 29.3-14.5L130 66Zm62.2-46.4c.7 0 1.3 0 2 .1 1.4.1 2.8.3 4.2.5v16.9c-2.2-.8-4.5-1.2-6.9-1.2-13.8 0-19.5 9-19.5 18.6V90.4h-16.9V21.2H172v6.4c4.5-6.3 12.3-8 19.5-8h.7Z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="a">
                        <path fill="#fff" d="M0 0h644.6v112.3H0z" />
                    </clipPath>
                </defs>
            </StyledSVG>
        )
    } else if (isPrideLogoEnabled) {
        return (
            <StyledSVGWrap>
                <StyledSVG
                    className={className}
                    width={width}
                    height={height}
                    viewBox="0 0 220 40"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <title>PN-for-pride_logo</title>
                    <defs>
                        <linearGradient
                            x1="4.08880714%"
                            y1="50.0135851%"
                            x2="97.0301323%"
                            y2="50.0135851%"
                            id="linearGradient-1"
                        >
                            <stop stopColor="#E10D17" offset="0%"></stop>
                            <stop stopColor="#FD8300" offset="21.33%"></stop>
                            <stop stopColor="#FD8A02" offset="24.58%"></stop>
                            <stop stopColor="#FD9E06" offset="29.37%"></stop>
                            <stop stopColor="#FDBE0D" offset="35.08%"></stop>
                            <stop stopColor="#FDD412" offset="38.34%"></stop>
                            <stop stopColor="#F6D113" offset="40.13%"></stop>
                            <stop stopColor="#E2CA15" offset="42.78%"></stop>
                            <stop stopColor="#C1BE18" offset="45.96%"></stop>
                            <stop stopColor="#94AE1D" offset="49.55%"></stop>
                            <stop stopColor="#599922" offset="53.48%"></stop>
                            <stop stopColor="#138029" offset="57.65%"></stop>
                            <stop stopColor="#0E7E2A" offset="57.94%"></stop>
                            <stop stopColor="#0F56FB" offset="80.23%"></stop>
                            <stop stopColor="#751487" offset="100%"></stop>
                        </linearGradient>
                    </defs>
                    <g
                        id="Page-1"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g id="PN-for-pride_logo" fillRule="nonzero">
                            <path
                                d="M208.584592,0 L123.97432,0 C117.676737,0 112.558912,5.05135952 112.558912,11.2824773 L112.558912,27.0015106 C112.558912,33.2326284 117.676737,38.2839879 123.97432,38.2839879 L208.584592,38.2839879 C214.882175,38.2839879 220,33.2326284 220,27.0015106 L220,11.2824773 C220,5.05135952 214.898792,0 208.584592,0 Z M143.697885,30.7734139 L137.749245,30.7734139 L137.749245,18.8927492 C137.749245,16.3006042 137.549849,11.9969789 133.379154,11.9969789 C129.457704,11.9969789 127.929003,14.8383686 127.929003,17.9622356 L127.929003,30.7567976 L121.980363,30.7567976 L121.980363,7.31117825 L127.629909,7.31117825 L127.629909,11.0664653 L127.729607,11.0664653 C128.826284,8.72356495 131.05287,6.71299094 135.024169,6.71299094 C141.42145,6.71299094 143.697885,11.1661631 143.697885,15.9516616 L143.697885,30.7734139 L143.697885,30.7734139 Z M159.234139,31.3549849 C152.039275,31.3549849 146.29003,26.4199396 146.29003,19.0422961 C146.29003,11.6646526 152.039275,6.72960725 159.234139,6.72960725 C166.429003,6.72960725 172.178248,11.6646526 172.178248,19.0422961 C172.178248,26.4199396 166.429003,31.3549849 159.234139,31.3549849 Z M202.635952,30.7734139 L196.73716,30.7734139 L191.087613,14.755287 L190.987915,14.755287 L185.986405,30.7734139 L179.838369,30.7734139 L171.530211,7.31117825 L177.977341,7.31117825 L183.145015,23.7280967 L183.244713,23.7280967 L188.063444,7.31117825 L194.510574,7.31117825 L199.661631,23.7280967 L199.761329,23.7280967 L204.712991,7.31117825 L210.71148,7.31117825 L202.635952,30.7734139 Z M159.234139,11.9969789 C154.864048,11.9969789 152.238671,15.3700906 152.238671,19.0256798 C152.238671,22.6978852 154.864048,26.0543807 159.234139,26.0543807 C163.60423,26.0543807 166.229607,22.6812689 166.229607,19.0256798 C166.229607,15.3700906 163.60423,11.9969789 159.234139,11.9969789 Z"
                                id="Now"
                                fill="url(#linearGradient-1)"
                            ></path>

                            <path
                                d="M12.429003,7.16163142 C19.2749245,7.16163142 24.8247734,12.6117825 24.8247734,19.3413897 C24.8247734,26.0543807 19.2749245,31.5045317 12.429003,31.5045317 C9.96978852,31.5045317 7.67673716,30.7900302 5.74924471,29.5770393 L5.74924471,29.5770393 L5.74924471,38.2507553 L0,38.2507553 L0,19.5574018 L0.0498489426,19.4909366 L0.0498489426,19.4909366 L0.0332326284,19.3247734 C0.0332326284,12.6117825 5.58308157,7.16163142 12.429003,7.16163142 Z M38.7990937,7.17824773 C45.6450151,7.17824773 51.194864,12.6283988 51.194864,19.3413897 C51.194864,19.9728097 51.1616314,20.5876133 51.0951662,21.2190332 L51.0951662,21.2190332 L32.3353474,21.2190332 C33.1495468,23.9441088 35.7250755,25.9380665 38.7824773,25.9380665 C41.1087613,25.9380665 43.152568,24.7749245 44.3655589,23.0135952 L44.3655589,23.0135952 L48.7854985,26.5528701 C46.5256798,29.560423 42.9033233,31.5045317 38.7990937,31.5045317 C31.9531722,31.5045317 26.4033233,26.0543807 26.4033233,19.3413897 C26.4033233,12.6283988 31.9531722,7.17824773 38.7990937,7.17824773 Z M90.7915408,0.51510574 L90.7915408,9.48791541 C92.8187311,7.79305136 94.9954683,7.16163142 97.4380665,7.16163142 C104.81571,7.16163142 107.806647,11.5981873 107.839879,19.3081571 L107.839879,19.3081571 L107.839879,31.3383686 L102.090634,31.3383686 L102.090369,18.7781631 C102.089305,18.3889426 102.083988,17.9422961 102.057402,17.4637462 C102.057402,14.7719033 100.096677,12.7114804 97.0392749,12.7114804 C92.2537764,12.7114804 90.7915408,15.5528701 90.7915408,18.3111782 L90.7915408,18.3111782 L90.7915408,31.3217523 L85.0422961,31.3217523 L85.0422961,0.51510574 L90.7915408,0.51510574 Z M65.6012085,7.16163142 C65.8338369,7.16163142 66.0664653,7.17824773 66.2824773,7.21148036 C66.7643505,7.24471299 67.2296073,7.31117825 67.6782477,7.39425982 L67.6782477,7.39425982 L67.6782477,13.1435045 C66.9471299,12.8776435 66.1661631,12.7280967 65.3353474,12.7280967 C60.6329305,12.7280967 58.6888218,15.8021148 58.6888218,19.0755287 L58.6888218,19.0755287 L58.6888218,31.3383686 L52.939577,31.3383686 L52.939577,7.74320242 L58.6888218,7.74320242 L58.6888218,9.90332326 C60.2009063,7.74320242 62.8927492,7.16163142 65.3353474,7.16163142 L65.3353474,7.16163142 Z M75.6042296,1.09667674 L75.6042296,7.74320242 L81.9516616,7.74320242 L81.9516616,12.6117825 L75.6208459,12.6117825 L75.6208459,19.358006 C75.6208459,20.255287 75.7205438,21.0362538 75.9199396,21.5181269 C76.7673716,23.6117825 79.2930514,25.5392749 81.9516616,25.6555891 C82.0513595,25.6555891 82.1676737,25.6722054 82.2673716,25.6722054 L82.2673716,25.6722054 L82.2673716,31.2386707 C76.2356495,31.2386707 71.2009063,27.0181269 70.0876133,21.418429 C69.9380665,20.6706949 69.8549849,18.9758308 69.8549849,18.1782477 L69.8549849,18.1782477 L69.8549849,1.09667674 L75.6042296,1.09667674 Z M12.429003,12.7114804 C8.70694864,12.7114804 5.69939577,15.6691843 5.69939577,19.3247734 C5.69939577,22.9803625 8.70694864,25.9380665 12.429003,25.9380665 C14.7054381,25.9380665 16.7326284,24.8247734 17.9622356,23.0966767 C18.6933535,21.9667674 19.092145,20.6042296 19.092145,19.1918429 C19.092145,18.5271903 18.9924471,17.8791541 18.826284,17.2477341 C17.929003,14.6057402 15.4033233,12.7114804 12.429003,12.7114804 Z M38.7824773,12.7280967 C35.8912387,12.7280967 33.4320242,14.5060423 32.4848943,17.0151057 L32.4848943,17.0151057 L45.0800604,17.0151057 C44.1329305,14.5060423 41.673716,12.7280967 38.7824773,12.7280967 Z"
                                id="Perth"
                                fill={textColor}
                            ></path>
                        </g>
                    </g>
                </StyledSVG>
            </StyledSVGWrap>
        )
    }
    return (
        <StyledSVG
            className={className}
            width={width}
            height={height}
            viewBox="0 0 220 40"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Perth Now</title>
            <defs>
                <path id="a" d="M.15 10.07h7.83V.04H.15z" />
                <path id="c" d="M0 13.3h88.5V0H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M123.7.27c-6.28 0-11.38 5.02-11.38 11.2v15.6c0 6.17 5.1 11.2 11.4 11.2h84.42c6.3 0 11.4-5.03 11.4-11.2v-15.6c0-6.18-5.1-11.2-11.4-11.2H123.7z"
                />
                <path d="M125.2 4.4c-4.9 0-8.9 3.96-8.9 8.84v6.4c.03-4.86 4-8.8 8.9-8.8h81.85c4.6 0 8.4 3.5 8.86 7.97v-6.4c-.4-4.4-4.2-7.9-8.8-7.9h-81.9z" />
                <path
                    fill={colors.white}
                    d="M121.7 7.53h5.66v3.73h.1c1.1-2.33 3.3-4.32 7.27-4.32 6.4 0 8.67 4.42 8.67 9.16v14.7h-5.94V19c0-2.56-.2-6.82-4.36-6.82-3.9 0-5.45 2.8-5.45 5.9v12.7h-5.94V7.54zm37.2 18.6c4.34 0 6.97-3.34 6.97-6.97 0-3.64-2.63-6.98-6.98-6.98-4.4 0-7 3.34-7 6.98 0 3.63 2.6 6.98 7 6.98m0-19.2c7.1 0 12.9 4.9 12.9 12.22s-5.8 12.2-12.9 12.2c-7.2 0-13-4.88-13-12.2 0-7.32 5.7-12.2 12.9-12.2m12.3.57h6.4l5.13 16.28h.1l4.8-16.2H194l5.15 16.3h.1l4.95-16.3h6l-8.02 23.2h-5.9l-5.63-15.9h-.1l-5 15.9h-6.14"
                />
                <path
                    fill={textColor}
                    d="M12.4 25.5c-3.7 0-6.72-2.93-6.72-6.54 0-3.62 3-6.56 6.72-6.56 2.98 0 5.5 1.9 6.38 4.5.17.62.26 1.27.26 1.93 0 1.4-.4 2.75-1.13 3.88-1.2 1.7-3.2 2.8-5.5 2.8m0-18.6C5.6 6.9.1 12.3.1 19v.16l-.1.04v18.5h5.75v-8.6c1.93 1.2 4.2 1.9 6.66 1.9 6.9 0 12.4-5.4 12.4-12.05 0-6.67-5.5-12.07-12.4-12.07m95.2 12.05c0-7.65-3-12.04-10.3-12.04-2.4 0-4.6.6-6.6 2.3V.3h-5.8v30.56h5.76v-12.9c0-2.73 1.46-5.56 6.25-5.56 3.05 0 5 2.05 5 4.7.04.6.05 1.15.05 1.6v12.16h5.7V18.93m-31.85 2.2c-.2-.48-.3-1.26-.3-2.15v-6.7h6.3v-4.8h-6.3V.85h-5.8V17.8c0 .8.1 2.5.23 3.24 1.1 5.55 6.12 9.74 12.14 9.74v-5.5l-.32-.03c-2.64-.13-5.16-2.05-6-4.12zM38.7 12.4c2.88 0 5.33 1.77 6.28 4.26H32.4c.97-2.5 3.4-4.26 6.3-4.26zm5.57 10.2c-1.2 1.76-3.25 2.9-5.57 2.9-3.05 0-5.62-1.97-6.44-4.68h18.7c.07-.62.1-1.23.1-1.87 0-6.66-5.53-12.06-12.37-12.06-6.9 0-12.4 5.4-12.4 12 0 6.7 5.5 12.1 12.4 12.1 4.1 0 7.7-2 9.9-4.9l-4.4-3.5zM66.15 6.93c-.23-.02-.45-.04-.68-.04h-.26c-2.4 0-5.1.5-6.6 2.7V7.4h-5.7v23.4h5.8V18.7c0-3.26 1.96-6.3 6.65-6.3.84 0 1.6.15 2.35.42v-5.7c-.47-.1-.94-.15-1.4-.2"
                />
            </g>
        </StyledSVG>
    )
}
PerthNowLogoHorizontal.displayName = 'PerthNowLogoHorizontal'

export const PerthNowLogoVertical: React.FC<PerthNowLogoHorizontalProps> = ({
    className,
    width = 101,
    height = 74,
    textColor = colors.black,
}) => (
    <StyledSVG
        className={className}
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 65 48"
    >
        <g>
            <path
                d="M6.8 24C3.1 24 0 27.2 0 31.1v9.8C0 44.8 3.1 48 6.8 48h51.3c3.8 0 6.8-3.2 6.8-7.1v-9.8c0-3.9-3.1-7.1-6.8-7.1H6.8"
                fillRule="evenodd"
                clipRule="evenodd"
                fill={colors.perthnow.redRuby}
            />
            <path
                fill="none"
                d="M29 32.2c-2.7 0-4.3 2.1-4.3 4.3 0 2.2 1.6 4.3 4.3 4.3 2.7 0 4.3-2.1 4.3-4.3 0-2.2-1.6-4.3-4.3-4.3z"
            />
            <path
                fill={colors.white}
                d="M57.3 29l-3 9.8h-.1L51.1 29h-4l-2.9 9.8h-.1L40.9 29H37l5.1 14h3.7l3.1-9.6h.1l3.4 9.6H56l5-14zM29 29c-4.4 0-8 3-8 7.5s3.6 7.5 8 7.5 8-3 8-7.5-3.6-7.5-8-7.5zm0 11.8c-2.7 0-4.3-2.1-4.3-4.3 0-2.2 1.6-4.3 4.3-4.3 2.7 0 4.3 2.1 4.3 4.3 0 2.2-1.6 4.3-4.3 4.3zM13.8 29c-2.4 0-3.7 1.3-4.4 2.7v-2.3H6V44h3.6v-8c0-2 .9-3.7 3.3-3.7 2.5 0 2.6 2.7 2.6 4.3V44H19v-9.2c0-3-1.4-5.8-5.2-5.8z"
            />
            <path
                fill="none"
                d="M7.5 7.4c-2.2 0-4.1 1.8-4.1 4s1.8 4 4.1 4c1.4 0 2.6-.7 3.3-1.7.4-.7.7-1.5.7-2.4 0-.4-.1-.8-.2-1.2-.5-1.5-2-2.7-3.8-2.7zM23.5 7.4c-1.7 0-3.2 1.1-3.8 2.6h7.6c-.6-1.5-2.1-2.6-3.8-2.6z"
            />
            <path
                fill={textColor}
                d="M65 11c0-4.5-1.9-7.1-6.4-7.1-1.5 0-2.8.4-4.1 1.4V0H51v18h3.5v-7.6c0-1.6.9-3.3 3.8-3.3 1.9 0 3.1 1.2 3.1 2.8V18H65v-7zM48.8 15.7c-1.5-.1-2.9-1.2-3.4-2.5-.1-.3-.2-.8-.2-1.3v-4h3.6V5h-3.6V1H42v10.2c0 .5 0 1.5.1 1.9.6 3.3 3.5 5.9 6.9 5.9v-3.3h-.2zM39.7 4h-.2c-1.5 0-3.1.4-4.1 1.7V4.4H32V19h3.5V11.3c0-2 1.2-3.9 4.1-3.9.5 0 1 .1 1.4.3V4.1c-.3-.1-.6-.1-.9-.1h-.4zM23.5 4C19.4 4 16 7.4 16 11.5s3.4 7.5 7.5 7.5c2.5 0 4.7-1.2 6-3.1l-2.7-2.2c-.7 1.1-2 1.8-3.4 1.8-1.8 0-3.4-1.2-3.9-2.9h11.3c0-.4.1-.8.1-1.2.1-4-3.3-7.4-7.4-7.4zm-3.8 6.1c.6-1.5 2.1-2.6 3.8-2.6 1.7 0 3.2 1.1 3.8 2.6h-7.6zM7.5 4C3.4 4 0 7.3 0 11.4V23h3.5v-5.3c1.2.7 2.5 1.2 4 1.2 4.1 0 7.5-3.3 7.5-7.4C15 7.3 11.6 4 7.5 4zm3.3 9.8c-.7 1-2 1.7-3.3 1.7-2.2 0-4.1-1.8-4.1-4s1.8-4 4.1-4c1.8 0 3.3 1.2 3.9 2.8.1.4.2.8.2 1.2-.1.7-.3 1.6-.8 2.3z"
            />
        </g>
    </StyledSVG>
)
PerthNowLogoVertical.displayName = 'PerthNowLogoVertical'
